import React from "react";

const MailUs = ({ category }) => {
  return (
    <div className="col-md-4 my-3">
      <div className="card h-100 no-border">
        <div className="w-100 text-center icon">
          <img className="p-2" src={category.image} />
        </div>
        <div className="card-body text-center pb-0 main-countainer">
          <h4 className="font-weight-bold main-title">{category.title}</h4>
          <h6 className="sub-title">Customer Support</h6>
          <p className="font-weight-normal px-md-2">
            M.S 10501 P.O. Box 29093 Phoenix AZ 85038
          </p>
        </div>
      </div>
    </div>
  );
};

export default MailUs;
